import { InitialState } from '@client/monolith/legacy/store/account/orderpay/index';
import { GetOrderPayAccountStatusEnum1 } from '@ankorstore/api-internal/data-contracts';
import { isBefore, parseISO } from 'date-fns';

export const getters = {
  isOrderPayUser: (state: InitialState) => !!state.status,
  getOrderpayAccountStatus: (state: InitialState) => state.status?.attributes.subscription?.status,
  isActiveOrderpayAccount: (state: InitialState) => {
    const isActiveSubscription = state.status?.attributes.subscription?.status === GetOrderPayAccountStatusEnum1.Active
    const subscriptionExpirationDate = state.status?.attributes.subscription?.expiresAt;
    const now = new Date().toISOString();
    return isActiveSubscription || (subscriptionExpirationDate && isBefore(parseISO(now), parseISO(subscriptionExpirationDate)));
  },
  isSubscriptionCancelled: (state: InitialState) => state.status?.attributes.subscription?.status === GetOrderPayAccountStatusEnum1.Cancelled,
  getSubscriptionExpirationDate: (state: InitialState) => state.status?.attributes.subscription?.expiresAt
};
